import { useCallback, useMemo, useState, type ReactNode } from 'react'

import { WorkInFlightContext } from './context'

export function WorkInFlightProvider({ children }: { children: ReactNode }) {
  const [busy, setBusyState] = useState(false)
  const setBusy = useCallback((next: boolean) => setBusyState(next), [])
  const value = useMemo(() => ({ busy, setBusy }), [busy, setBusy])
  return <WorkInFlightContext.Provider value={value}>{children}</WorkInFlightContext.Provider>
}
